<template>
    <transition name="fade">
        <div id="background" @click.stop="removePopup">
            <div id="popup" :class="{ live: store.live }">
                <div id="close" :class="{ live: store.live }"></div>
                <p>
                    To add shows to your favorites become
                    a Montez Press Radio Supporter.
                </p>
                <router-link :to="{ name: 'subscribe' }">Become a MPR Supporter</router-link>
                <p>Already supporting MPR? Please login:</p>
                <router-link :to="{ name: 'login' }">Login</router-link>
            </div>
        </div>
    </transition>
</template>

<script>
import { store } from "../store";

export default {
    name: "SupportPopup",
    data() {
        return {
            store: store,
        };
    },
    //computed: {
    //status(){
    //if (this.store.live){
    //return 'Live'
    //} else {
    //return 'Archive'
    //}
    //}
    //},
    methods: {
        removePopup() {
            this.store.showLikePopup = false;
        },
    },
};
</script>

<style scoped>
#background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    backdrop-filter: blur(30px);
    background-color: rgba(255, 255, 255, 0.4);
    z-index: 3;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

@-moz-document url-prefix() {
    #background {
        background-color: rgba(255, 255, 255, 0.9) !important;
    }
}

#popup {
    background-color: #f9f57d;
    /* position: fixed; */
    /* top: 50%; */
    /* left: 50%; */
    padding: 6rem 20px 0;
    /* width: calc(100vw - 40px); */
    /* height: calc(100vh - 12rem); */
    /* transform: translate(-50%, -50%); */
    width: min(550px, 100%);
    box-sizing: border-box;
    flex-grow: 1;
}

#popup.live {
    padding: 10rem 20px 0;
    /* height: calc(100vh - 20rem); */
}

@media only screen and (min-width: 550px) {

    #popup,
    #popup.live {
        /*         width: 60vw; */
        flex-grow: 0;
        padding: 1rem 1.5rem;
    }
}

/* @media only screen and (min-width: 1101px) { */
/*     #popup, */
/*     #popup.live { */
/*         width: 30vw; */
/*         padding: 1rem 1.5rem; */
/*     } */
/* } */
#close {
    position: absolute;
    right: 20px;
    top: 5rem;
    width: 13px;
    height: 15px;
    cursor: pointer;
}

#close.live {
    top: 9rem;
}

#close:before,
#close:after {
    position: absolute;
    left: 6px;
    content: " ";
    height: 17px;
    width: 1px;
    background-color: black;
}

#close:before {
    transform: rotate(45deg);
}

#close:after {
    transform: rotate(-45deg);
}

@media only screen and (min-width: 550px) {
    #close {
        display: none;
    }
}

p {
    text-align: center;
}

a {
    border: 1px solid black;
    padding: 0.65rem 1rem 0.85rem;
    width: 100%;
    display: inline-block;
    box-sizing: border-box;
    text-align: center;
    margin-bottom: 1rem;
}

a:hover {
    background-color: black;
    color: #fcfac4;
}

.fade-enter-active {
    transition: opacity 0.5s;
}

.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
